<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <!-- Pages -->
                <div class="col-md-12">
                    <tab-navigation>
                        <ul>
                            <li>
                                <router-link :to="{name: 'backend.system.mails'}">
                                    {{$t('system.mails')}}
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'backend.system.mails.quarantine'}">
                                    {{$t('system.quarantine')}}
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'backend.system.jobs'}">
                                    {{$t('system.jobs.jobs')}}
                                </router-link>
                            </li>
                        </ul>

                        <div class="clearfix"></div>

                        <hr />

                        <router-view></router-view>
                    </tab-navigation>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
</style>

<script>
import Card from '@/app/shared/components/Card'
import TabNavigation from '@/app/layout/components/TabNavigation'

export default {
    computed: {
        routeName() {
            return this.$route.name;
        }
    },

    watch: {
        routeName() {
            this.checkRoute();
        }
    },

    mounted() {
        this.checkRoute();
    },

    methods: {
        checkRoute() {
            var routeName = this.routeName;

            if (routeName == 'backend.system') {
                this.$router.push({
                    name: 'backend.system.mails'
                });
            }
        }
    },

    components: {
        Card,
        TabNavigation
    }
}
</script>
